// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiePopUp_container__F118B","privacyPolicy":"CookiePopUp_privacyPolicy__nSlms"};